export default __webpack_public_path__ + "static/media/talkingTimber.a3459d84.jpg";